import React from 'react';

import { ReactComponent as AddIcon } from 'pages/Teachers/Home/assets/add-icon.svg';
import { ReactComponent as DocumentIcon } from 'pages/Teachers/Home/assets/document-icon.svg';

import styles from './styles.module.scss';

const DashboardHeader = ({ setIsLogged }) => {
  return (
    <header className={styles.header}>
      <div className={styles.headerActions}>
        <button className={styles.iconBtn}>
          <DocumentIcon />
        </button>
        <button
          // TODO: Replace with adequate implementation (used to resolve error)
          onClick={() => {
            setIsLogged(false);
          }}
          className={styles.createBtn}
        >
          <span className={styles.addIconWrapper}>
            <AddIcon />
          </span>
          <span>Create Assignment</span>
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;
